import { Box, Stack } from '@mui/material'
import { useGetCustomersLocalitiesForMap } from '../../api/customer'
import { Spinner } from '../../components/Spinner'
import { ILocality } from '../../generated-types'
import LocalityLandingMap from './components/localityMap/LocalityLadingMap'
import EmptyMap from './components/map/EmptyMap'

export const LocalitiesMapComponent: React.FC<{ selectedCustomer: EntityId; searchValue: string }> = ({
  selectedCustomer,
  searchValue,
}) => {
  const { data, isLoading } = useGetCustomersLocalitiesForMap(searchValue, selectedCustomer)
  return (
    <Box height={((window.innerHeight - 180) * 2) / 3}>
      {isLoading ? (
        <Stack
          direction={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'100%'}
          data-test-id="map-loading"
        >
          <Spinner />
        </Stack>
      ) : data && data?.length > 0 ? (
        <LocalityLandingMap
          localities={data as ILocality[]}
          customerId={selectedCustomer}
          key={'locality-main-page-map'}
          customUrl={'https://tile.openstreetmap.org/{z}/{x}/{y}.png'}
        />
      ) : (
        <EmptyMap />
      )}
    </Box>
  )
}
